import * as React from 'react'

import { Dropdown } from '@factorialco/f0-react/dist/experimental'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

interface Props {
  onSelect: (value: string) => void
  showJobData?: boolean
  showSenderData?: boolean
}

const AtsMessageVariablesSelectorComponent = ({ onSelect, showJobData, showSenderData }: Props) => {
  const candidateData = [
    {
      value: '{{candidate.first_name}}',
      label: i18n.t('ats.manage_message_templates.variables.candidate_first_name'),
    },
    {
      value: '{{candidate.last_name}}',
      label: i18n.t('ats.manage_message_templates.variables.candidate_last_name'),
    },
    {
      value: '{{candidate.email}}',
      label: i18n.t('ats.manage_message_templates.variables.candidate_email'),
    },
  ]
  const jobData = [
    {
      value: '{{job_opening.title}}',
      label: i18n.t('ats.manage_message_templates.variables.job_opening_title'),
    },
    {
      value: '{{job_opening.team}}',
      label: i18n.t('ats.manage_message_templates.variables.job_opening_team'),
    },
    {
      value: '{{job_opening.workplace}}',
      label: i18n.t('ats.manage_message_templates.variables.job_opening_workplace'),
    },
  ]
  const senderData = [
    {
      value: '{{sender.full_name}}',
      label: i18n.t('ats.manage_message_templates.variables.sender_full_name'),
    },
  ]
  const companyData = [
    {
      value: '{{company.name}}',
      label: i18n.t('ats.manage_message_templates.variables.company_name'),
    },
  ]

  // Company and cadidate data variables are always shown
  const getVariablesOptions = () => {
    const options = [...companyData]

    if (showSenderData) options.push(...senderData)
    options.push(...candidateData)
    if (showJobData) options.push(...jobData)

    return options
  }

  const variablesOptions = getVariablesOptions()

  const dropdownItems = variablesOptions.map((option) => ({
    label: option.label,
    onClick: () => onSelect(option.value),
  }))

  return (
    <Dropdown
      items={dropdownItems}
      label={i18n.t('ats.manage_message_templates.add_variables')}
      align="end"
    />
  )
}

export const AtsMessageVariablesSelector = observer(AtsMessageVariablesSelectorComponent)
